import type { SiteDocument } from '../types/siteRag';

/** Keep each visible child immediately below its email without hiding independently matched children. */
export function orderEmailAttachments(docs: readonly SiteDocument[]): SiteDocument[] {
  const ids = new Set(docs.map(d => d.id));
  const children = new Map<string, SiteDocument[]>();
  for (const doc of docs) {
    if (doc.parentDocId && doc.parentDocId !== doc.id && ids.has(doc.parentDocId)) {
      const group = children.get(doc.parentDocId) ?? [];
      group.push(doc);
      children.set(doc.parentDocId, group);
    }
  }
  const emitted = new Set<string>();
  const out: SiteDocument[] = [];
  const emit = (doc: SiteDocument) => {
    if (emitted.has(doc.id)) return;
    emitted.add(doc.id);
    out.push(doc);
    for (const child of children.get(doc.id) ?? []) emit(child);
  };
  for (const doc of docs) if (!doc.parentDocId || !ids.has(doc.parentDocId)) emit(doc);
  for (const doc of docs) emit(doc); // defensive cycle/orphan handling
  return out;
}
